import React from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { history } from '@/browserHistory'
import { EAuthButtonVariant } from '@/components/ui/AuthButton/constants'
import { Button } from '..'
import { isStartAuthModalAvailable, useAuthenticateUser } from './hooks'
import type { IAuthButtonOwnProps } from './interfaces'

const AuthButton: React.FC<IAuthButtonOwnProps> = props => {
  const {
    children,
    buttonProps,
    onClick,
    shouldHideForAuthenticatedUser,
    shouldRedirectToProfileIfAuth,
    variant = EAuthButtonVariant.DIALOG_ONLY,
  } = props
  const { profilePath, isAuthenticated, logoutUser, openAuthModal } = useAuthenticateUser()
  const queryClient = useQueryClient()

  const handleClick = async (event: Event) => {
    if (shouldRedirectToProfileIfAuth && profilePath && isAuthenticated) {
      history.push(profilePath)
    } else if (isAuthenticated) {
      logoutUser()
      queryClient.clear()
    } else {
      const shouldUseStartAuthModal =
        variant === EAuthButtonVariant.DIALOG_WITH_REDIRECT_TO_SEPARATE_REGISTRATION_PAGE && (await isStartAuthModalAvailable())

      const dialogId = shouldUseStartAuthModal ? 'StartAuthModal' : 'AuthModal'

      openAuthModal(undefined, dialogId)
    }

    onClick?.(isAuthenticated, event)
  }

  if (shouldHideForAuthenticatedUser && isAuthenticated) {
    return null
  }

  return (
    <Button isUnstyled {...buttonProps} onClick={handleClick}>
      {children}
    </Button>
  )
}

export default AuthButton
